module.exports = __webpack_public_path__ + "static/background-3c10782a714b4e884bcc4cfd58a352be.jpeg";